import { debugLog } from './debug';

const env = (typeof window !== 'undefined' && window._env_) || {};
const CHATWOOT_URL = (env.REACT_APP_CHATWOOT_URL || '').replace(/\/$/, '');
const ACCOUNT_ID = env.REACT_APP_CHATWOOT_ACCOUNT_ID || '1';
const TOKEN = env.REACT_APP_CHATWOOT_TOKEN || '';
const INBOX_ID = env.REACT_APP_CHATWOOT_INBOX_ID || '';
const chatwootHeaders = {
  'Content-Type': 'application/json',
  'api_access_token': TOKEN,
};

async function chatwootFetch(endpoint, options = {}) {
  const url = `${CHATWOOT_URL}/api/v1/accounts/${ACCOUNT_ID}${endpoint}`;
  debugLog('chatwootFetch', url, options);
  try {
    const response = await fetch(url, { ...options, headers: chatwootHeaders });
    const responseText = await response.text();
    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch {
      responseData = responseText;
    }
    if (!response.ok) {
      const errorDetails = {
        message: `Erro na API: ${url} ${response.status}`,
        status: response.status,
        url,
        method: options.method || 'GET',
        requestBody: options.body,
        headers: chatwootHeaders,
        response: responseData,
        stack: (new Error()).stack
      };
      debugLog('Detalhes do erro Chatwoot:', errorDetails);
      const error = new Error(errorDetails.message);
      Object.assign(error, errorDetails);
      throw error;
    }
    return responseData;
  } catch (error) {
    debugLog('Erro na requisição Chatwoot:', error);
    throw error;
  }
}

debugLog('api.js: módulo carregado');

// Retorna contatos. Se INBOX_ID estiver definido, retorna apenas
// contatos que têm conversa na inbox (deduplicado por id).
export async function getContacts() {
  debugLog('api.js: getContacts chamado, INBOX_ID=', INBOX_ID);
  try {
    if (!INBOX_ID) {
      const data = await chatwootFetch('/contacts');
      return data.payload || [];
    }
    const byId = {};
    let page = 1;
    while (true) {
      const resp = await chatwootFetch(`/conversations?inbox_id=${INBOX_ID}&status=all&page=${page}`);
      const convs = resp?.data?.payload || [];
      if (convs.length === 0) break;
      for (const conv of convs) {
        const sender = conv?.meta?.sender;
        if (sender && sender.id != null) byId[sender.id] = sender;
      }
      if (convs.length < 25) break;
      page += 1;
      if (page > 200) break;
    }
    return Object.values(byId);
  } catch (error) {
    debugLog('Erro ao buscar contatos:', error);
    throw error;
  }
}

// Retorna todos os atributos customizados (lista) apenas do tipo contact_attribute
export async function getCustomAttributes() {
  debugLog('api.js: getCustomAttributes chamado');
  try {
    // Busca todos os atributos customizados
    const data = await chatwootFetch('/custom_attribute_definitions');
    // Filtra apenas os de contato
    const all = data.payload || data || [];
    const filtered = Array.isArray(all)
      ? all.filter(attr => attr.attribute_model === 'contact_attribute')
      : [];
    return filtered;
  } catch (error) {
    debugLog('Erro ao buscar atributos customizados:', error);
    throw error;
  }
}

// Retorna um atributo customizado específico pelo ID
export async function getCustomAttributeById(id) {
  debugLog('api.js: getCustomAttributeById chamado', id);
  try {
    const data = await chatwootFetch(`/custom_attribute_definitions/${id}`);
    return data.payload || data; // pode vir como objeto direto
  } catch (error) {
    debugLog('Erro ao buscar atributo customizado por ID:', error);
    throw error;
  }
}

// Atualiza o valor de um atributo customizado do contato
export async function updateContactCustomAttribute(contactId, attributeKey, value) {
  debugLog('api.js: updateContactCustomAttribute chamado', contactId, attributeKey, value);
  try {
    return await chatwootFetch(`/contacts/${contactId}`, {
      method: 'PUT',
      body: JSON.stringify({ custom_attributes: { [attributeKey]: value } })
    });
  } catch (error) {
    debugLog('Erro ao atualizar atributo customizado:', error);
    throw error;
  }
}